<template>
  <node-view-wrapper v-if="this.node.attrs.line.attributes" class="line">
    <!-- <div
    @mouseout="onMouseOut(node.attrs.line.attributes.id)" @mouseover="onMouseOver(node.attrs.line.attributes.id)"
      class="drag-handle"
      contenteditable="false"
      draggable="true"
      data-drag-handle
    /> -->
    <div
      @click="onMouseClick(node.attrs.line.attributes.id)"
      @dblclick="centerLine(node.attrs.line.attributes.id)"
      @mouseout="onMouseOut(node.attrs.line.attributes.id)"
      @mouseover="onMouseOver(node.attrs.line.attributes.id)"
    >
      <node-view-content :id="this.node.attrs.line.attributes.id">
      </node-view-content>
    </div>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from '@tiptap/vue-2'
import { mapState } from 'vuex'

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent
  },
  methods: {
    highlight(id) {
      this.$store.dispatch('content/highlight', {
        target: id,
        origin: 'content'
      })
    },
    centerLine(id) {
      this.$store.dispatch('content/centerLine', {
        target: id,
        origin: 'content',
      })
    },
    select(id) {
      this.$store.dispatch('content/select', {
        target: id,
        origin: 'content'
      })
    },
    onMouseOver(id) {
      this.highlight(id)
    },
    onMouseOut(id) {
      this.highlight(id)
    },
    onMouseClick(id) {
      this.select(id)
    }
  },

  props: nodeViewProps
}
</script>
